/**
 * Ad bileşenlerini tek boşlukla birleştirir; boş, boşluktan ibaret ya da
 * tanımsız olanları atlar.
 *
 * `RI.OnGetCustomerInfo` servisi ikinci adı ayrı bir alanda (`MiddleName`)
 * döndürür ve bu alan her müşteride dolu değildir. Ad gösterilen her yerde bu
 * fonksiyon kullanılmalıdır; şablon dizgesiyle elle birleştirmek
 * (`${name} ${middleName} ${surname}`) ikinci adı olmayan kullanıcılarda araya
 * fazladan boşluk bırakır ve `undefined` metnini ekrana basar.
 *
 * @example
 * formatFullName('MEHMET', 'ÜMİT', 'HAŞLAMAN'); // 'MEHMET ÜMİT HAŞLAMAN'
 * formatFullName('AYŞE', undefined, 'YILMAZ');  // 'AYŞE YILMAZ'
 */
const formatFullName = (...parts: (string | undefined | null)[]): string =>
  parts
    .map((part) => part?.trim())
    .filter((part): part is string => !!part)
    .join(' ');

export default formatFullName;
